import React from 'react'
import './button.scss'
import { ButtonStylesEnum } from 'types/buttonStylesEnum'
interface ButtonProps {
    children: React.ReactNode
    style?: ButtonStylesEnum | string
    icon?: React.ReactElement | string
    iconPos?: 'left' | 'right'
    onClick?: () => void
    size?: 'small' | 'large' | 'tall' | 'icon' | 'xl'
    className?: string
    id?: string
    disable?: boolean
    type?: 'button' | 'submit' | 'reset' | undefined
    ariaLabel?: string
}

export const Button = ({
    children,
    style,
    icon,
    size,
    iconPos,
    className,
    disable,
    type,
    ariaLabel,
    ...props
}: ButtonProps) => {
    const stylesOptions = {
        primary: 'btn__primary',
        secondary: 'btn_secondary',
        info: 'btn_info',
        warning: 'btn_warn',
        light: 'btn_light',
        danger: 'btn_danger',
        solid: 'btn_solid',
        outline: 'btn_outline'
    }
    const types = style && stylesOptions[style as ButtonStylesEnum]
    const raws = icon ? (
        iconPos === 'right' ? (
            <>
                <span>{children}</span> {icon}
            </>
        ) : (
            <>
                {icon} <span>{children}</span>
            </>
        )
    ) : (
        children
    )
    const disabledBtn = disable ? 'disabled-btn' : ''
    return (
        <button
            className={[
                'default__btn',
                types,
                `btn-size--${size || 'large'}`,
                disabledBtn,
                className
            ].join(' ')}
            {...props}
            disabled={disable}
            type={type}
            aria-label={ariaLabel}
        >
            {raws}
        </button>
    )
}
